<template>
  <div>
    <v-container class="ml-10">
      <p class="display-1 mt-7">결제 관리</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        소프트웨어 인증 서비스는 서버호스팅 비용(월)을 결제하여 사용이
        가능합니다.
      </p>

      <Payment></Payment>
      <PaymentList></PaymentList>
    </v-container>
  </div>
</template>

<script>
import Payment from "@/components/authservice/payment/Payment.vue";
import PaymentList from "@/components/authservice/payment/PaymentList.vue";

export default {
  components: {
    Payment,
    PaymentList
  }
};
</script>
